import { replace, toLower } from 'ramda';

export default replace(/([A-Z])/g, s => ` ${toLower(s)}`);
